<template>
  <scroll-bar>

    <el-menu
      :collapse="collapsed"
      :default-active="state.activeIndex"
      class="el-menu-vertical-demo sidebar"
      @open="handleOpen"
      background-color="#eeeeee"
      :collapse-transition="false"
      @close="handleClose">
      <el-menu-item index="-1" @click="toggleSidebar">
        <i :class="collapsed ? 'el-icon-arrow-right' : 'el-icon-arrow-left'"></i>
      </el-menu-item>
      <router-link v-for="(item, index) in items" :key="index" v-show="item.to" :index="item.to" :to="item.to">
        <el-menu-item :index="String(index)">
          <i :class="item.icon" v-if="item.icon"></i>
          <div v-if="!item.icon && collapsed" class="sidebar__icon-placeholder"></div>
          <span>{{item.name}}</span>
        </el-menu-item>
      </router-link>
    </el-menu>

    <slot name="opened" v-if="!collapsed"></slot>
    <slot name="collapsed" v-if="collapsed"></slot>

  </scroll-bar>
</template>

<script>
  import ScrollBar from '@/components/ScrollBar'
  import {mapGetters} from 'vuex'
  import {findLastIndex} from 'lodash'

  export default {
    components: {ScrollBar},
    data() {
      return {
        state: {
          collapsed: false,
          activeIndex: null
        }
      }
    },
    props: ['items'],
    computed: {
      ...mapGetters({
        sidebar: 'sidebar'
      }),
      collapsed() {
        return !this.sidebar.opened
      }
    },
    created() {
      this.setActiveIndex()
      this.$router.afterEach((to, from) => this.setActiveIndex())
    },
    methods: {
      setActiveIndex() {
        let activeRouteIndex = findLastIndex(this.items, item => {
          return this.$route.path.indexOf(item.to) >= 0
        })
        if (activeRouteIndex >= 0) {
          this.state.activeIndex = this.items[activeRouteIndex].to
        } else {
          this.state.activeIndex = null
        }
      },
      toggleSidebar() {
        this.$store.dispatch('toggleSideBar')
      },
      handleOpen() {

      },
      handleClose() {

      }
    }
  }
</script>

<style lang="scss">
  .sidebar {
    height: 100%;

    &__icon-placeholder{
      background: #b9bbc1;
      width: 20px;
      height: 20px;
      display: inline-block;
      margin-right: 5px;
      border-radius: 50% 50%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/sidebar/index.vue